var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 15,
    viewBox: "0 0 33 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 15,
    fill: "white",
    fillOpacity: 0.92
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4164 8.01752L12.4139 3.12053L11.0151 4.54952L17.4465 10.8454L23.7423 4.41392L22.3133 3.01506L17.4164 8.01752Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrow);
export default __webpack_public_path__ + "static/media/Downarrow.e1bfe36afdaf863746e37dfc086a5fa8.svg";
export { ForwardRef as ReactComponent };